var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print_tag",class:{
    is_one_col: _vm.setting.cols === 1,
  }},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.tagListDomString)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }